<template>
  <div class="ace-grain-beans-step-1 ace-content">
    <h2 class="ace-grain-beans-step-1__title">Select your feed material</h2>
    <ButtonGroup class="ace-grain-beans-step-1__buttons">
      <Button
        v-for="(feedMaterial, index) in feedMaterials"
        :key="index"
        variant="image"
        :images="feedMaterial.images"
        :text="feedMaterial.title"
        @click="$emit('setFeedMaterial', feedMaterial.name)"
      />
    </ButtonGroup>
  </div>
</template>

<script>
import ButtonGroup from '../Layout/ButtonGroup.vue';
import Button from '../Layout/Button.vue';

export default {
  data() {
    return {};
  },
  props: ['feedMaterials'],
  components: {
    ButtonGroup,
    Button,
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/mixins';

.ace-grain-beans-step-1 {
  max-width: 680px;
  &__title {
    @include title;
  }
  &__buttons {
    margin-top: 55px;
  }
}
</style>
